import { pressCategoryIds } from './mainCategoryIds';

const isPressRelease = (
  id: number | null | undefined,
  reference: string | null | undefined,
) => Boolean(
  (id && pressCategoryIds.includes(id))
  || reference === 'press',
);

export default isPressRelease;
